import gql from "graphql-tag";

export default gql`
  query BuildingListingQuery($id: ID!) {
    buildingListing(id: $id) {
      ... on BuildingListing {
        accessibilityInfo
        amenities {
          name
          active
          label
        }
        buildingAddress
        brandSegment
        buildingName
        buildingPhotos {
          tag
          caption
          mediumSrc
          xlargeSrc
          largeSrc
        }
        cityName
        contactEmailLtr
        contactEmailStr
        countryName
        countryCode
        currency
        downtownDrivingInfo
        geocode {
          lat
          lng
        }
        homeTruths
        houseRules
        id
        location
        neighborhoodContent
        neighborhoodDescription
        neighborhoodName
        parkingInfo
        photos {
          tag
          caption
          mediumSrc
          xlargeSrc
          largeSrc
        }
        publicTransportationInfo
        ratingAverage
        ratingState
        ratingTotal
        shortDescription
        stateName
        stateCode
        title
        topAmenities {
          name
          active
          label
        }
        tripadvisorAward {
          awardType
          year
          assetSrc
        }
        url
        isHotel
      }
      ... on Listing {
        l1Url
      }
    }
  }
`;
